import { classNames } from '../../_helpers'

type PropTypes = {
  logoUrl: string
  background?: string | null
  className?: string
}

// Das Logo liegt auf einer im CMS gewählten Hintergrundfarbe (weiß oder blau)
export const FestivalLogo = ({ logoUrl, background, className }: PropTypes) => {
  return (
    <img
      src={logoUrl}
      alt={''}
      className={classNames(
        'object-contain shadow-md',
        background === 'blue' ? 'bg-primary-200' : 'bg-white',
        className
      )}
    />
  )
}
